<div class="card border-0 py-5 align-self-stretch h-100 flex-grow-1">
  <!-- All three inputs should be initialized. -->
  <ng-container *ngIf="product; else spinner">
    <ng-container *ngIf="product.imageId; else graphicSpinner">
      <app-catalog-graphic imageClasses="card-img-top border"
                           [imageId]="product.imageId"
                           [imageSize]="120">
      </app-catalog-graphic>
    </ng-container>
    <ng-template #graphicSpinner>
      <div
        class="product-spinner spinner-image card-img-top border bg-white p-3 justify-content-center align-items-center d-flex">
        <app-spinner [size]="2"></app-spinner>
      </div>
    </ng-template>
    <h5 class="product-title card-title mt-3 mb-2 fw-bold">{{ product.title }}</h5>
    <h6 class="product-version card-text mb-3">{{ version }}</h6>
    <ul class="product-platforms card-body py-0 px-0 mb-3">
      <li *ngFor="let platform of platforms"
          class="border d-inline-block py-1 px-1 me-1 mb-1">
        <app-platform class="mx-2" [platform]="platform"></app-platform>
      </li>
    </ul>
    <a class="product-link btn btn-primary py-2 text-uppercase mb-auto w-100"
       [routerLink]="['/download-without-purchase', product.id, version]">Download</a>
  </ng-container>

  <ng-template #spinner>
    <div class="spinner">
      <div class="spinner-image card-img-top border bg-white p-3 justify-content-center align-items-center d-flex">
        <app-spinner [size]="2" class="d-block text-black-50 text-center"></app-spinner>
      </div>
      <h5 class="card-title mt-3 mb-2 fw-bold fake-text-header"></h5>
      <h6 class="mt-2 mb-3 fake-text"></h6>
      <ul class="card-body py-0 px-0 mb-3">
        <li class="border d-inline-block py-1 px-1 me-1 mb-1">
          <span class="invisible">Fake Platform</span>
        </li>
      </ul>

      <div role="progressbar" class="btn btn-secondary py-2 text-uppercase mb-auto w-100 disabled">Download</div>
    </div>
  </ng-template>
</div>
